import { render, staticRenderFns } from "./PostEditImmoObject2100.vue?vue&type=template&id=6a1d87d1&"
import script from "./PostEditImmoObject2100.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject2100.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports